import React from 'react';

const Article = ({
  imgUrl,
  subtext = '',
  title,
  description,
  bgColor = 'bg-white',
    subtextColor = 'text-gray-600'
}) => {
  return (
    <div className={`p-6 rounded-lg ${bgColor}`}>
      <div className="flex flex-col md:flex-row gap-6 items-start">
        <div className="flex-1">
          {subtext && (
            <span className={`${subtextColor} text-sm font-bold mb-2 block uppercase`}>
              {subtext}
            </span>
          )}
          <h2 className="text-xl font-semibold text-gray-900 mb-3">
            {title}
          </h2>
          <div className="text-gray-700">
            {description}
          </div>
        </div>

        <div className="w-32 flex-shrink-0">
          <img
            src={imgUrl}
            alt={title}
            className="w-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default Article;